import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Results header with title, print button, and count display
 * @param {Object} props - Component props
 * @param {Object} props.data - Search results data
 * @param {number} props.data.count - Total number of results
 * @param {string} props.data.query_time - Query execution time
 * @returns {JSX.Element} Results header
 */
const ResultsHeader = ({ data, onShare }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 mb-6 sm:mb-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-start">
        <h4 className="normal-case text-lg sm:text-xl font-medium">
          {t('active-substance|Search results')}
        </h4>

        <div className="flex flex-col gap-2 w-full sm:flex-row sm:w-auto sm:gap-2">
          <Button
            type="default"
            variant="outlined"
            size="medium"
            className="w-full sm:w-auto text-sm sm:text-base py-2.5 px-4 sm:py-2 sm:px-3"
          >
            {t('active-substance|Printable version')}
          </Button>
          <Button
            size="medium"
            type="primary"
            onClick={onShare}
            className="w-full sm:w-auto text-sm sm:text-base py-2.5 px-4 sm:py-2 sm:px-3 font-medium"
          >
            {t('common|Share results')}
          </Button>
        </div>
      </div>

      <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-0">
        <p className="text-sm sm:text-base text-gray-900">
          {t('active-substance|searchResultsCount', {
            count: data?.count || 0,
          })}
        </p>
        {data?.query_time && (
          <span className="text-xs sm:text-sm text-gray-500 sm:ml-2">
            ({data.query_time})
          </span>
        )}
      </div>
    </div>
  );
};

export default ResultsHeader;
